module.exports = __webpack_public_path__ + "static/media/cat.f5bf11de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/cat.svg
// module id = 476
// module chunks = 0